module.exports = __webpack_public_path__ + "static/media/klima-08.091cf3ef.jpg";